module.exports = __webpack_public_path__ + "static/media/harish_choudhary.5aba8b19.jpg";